import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class InternationalDomesticService implements OnDestroy {
  destroy$ = new Subject<void>();

  constructor(private store: Store) {}

  /**
   * check if destination changed from international to domestic or from domestic to international
   * */
  getInternationalDomesticStatus(previousQuoteDestinations: string[]) {
    const newQuoteDestinationInput = this.store.selectSnapshot(
      (state) => state.quote.input.destinationCountryCodes
    );
    const isNewQuoteDomestic = this.isDomestic(newQuoteDestinationInput);
    const isPreviousQuoteDomestic = this.isDomestic(previousQuoteDestinations);
    return {
      changeFromInternationToDomestic:
        isNewQuoteDomestic && !isPreviousQuoteDomestic,
      changeFromDomesticToInternational:
        !isNewQuoteDomestic && isPreviousQuoteDomestic,
    };
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private isDomestic(countries: string[]): boolean {
    if (countries?.length === 1 && countries[0] === 'AUS') {
      return true;
    }
    return false;
  }
}
